import React from 'react';
import GenericDialog from "../../common/GenericDialog";
import axios from "axios";

const RemoveUserAdminPermsDialog = ({ visible, handleClose, user }) => {
    const removeAdminPermission = async (userId) => {
        try {
            await axios.post(`/web/ui/sc/removeTeacherAdmin`, userId);
            return true;
        } catch (error) {
            console.error('Error removing admin permissions:', error);
            displayToastMessage('Failed to remove admin permissions. Try to remove the permissions again.', null, 'error', undefined, 10000);
            return false;
        }
    };

    const handleRemoveAdminPermission = async () => {
        const success = await removeAdminPermission([user.userId]);
        if (success) {
            displayToastMessage(`Permissions removed from ${user?.fullName} successfully.`, null, 'success', undefined, 10000);
            handleClose(true);
        }
    }

    return (
        <GenericDialog
            title={`Remove Administrator Permissions`}
            open={visible}
            dialogWidth={450}
            onClose={handleClose}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: {type: 'text'}
                },
                {
                    name: 'Remove Permissions',
                    callback: handleRemoveAdminPermission,
                    extraProps: {
                        type: 'primary'
                    }
                }
            ]}
        >
            <p><strong>{user?.fullName}</strong> will lose access to all administration functions.</p>
            <p>Are you sure you want to remove administrator permissions for this user?</p>
        </GenericDialog>
    );
};

export default RemoveUserAdminPermsDialog;